//import { HttpLink } from 'apollo-link-http';
// Still looking for where Observable comes into play within @apollo/client
// import {  Observable } from 'apollo-link';
//import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import { ApolloCache, InMemoryCache } from '@apollo/client/cache';
//import { onError } from 'apollo-link-error';
import { onError } from '@apollo/client/link/error';
//import { ApolloClient } from 'apollo-client';
import { ApolloClient, ApolloLink, HttpLink, Observable  } from '@apollo/client';
//import introspectionQueryResultData from './fragmentTypes.json';
import ActionCable from 'actioncable';
import ActionCableLink from 'graphql-ruby-client/subscriptions/ActionCableLink';

/**
 * This is the websockets URL.
 * Production and development both use the same browser host.
 * That keeps Render to one service/one port instead of hard-coding swyler.onrender.com.
 */
const getCableUrl =  () => {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const authToken =  localStorage.getItem('mlToken') || 'loggedouttoken';
    return `${protocol}//${window.location.host}/cable?token=${authToken}`;
};

/**
 * Used in creating a link to Action Cable on the Rails API
 */
const createActionCableLink = () => {
    const cable = ActionCable.createConsumer(getCableUrl());
    return new ActionCableLink({ cable });
};

const hasSubscriptionOperation = ({ query: { definitions } }) =>
    definitions.some(
        ({ kind, operation }) =>
            kind === 'OperationDefinition' && operation === 'subscription'
    );

/**
 * Grabs tokens from the document, used solely for websockets and not authorization
 */
const getTokens = async () => {
    const csrfTag = document.querySelector('meta[name="csrf-token"]');
    const tokens = csrfTag ? { "X-CSRF-Token": csrfTag.getAttribute("content") } : {};
    const authToken = await localStorage.getItem("mlToken");
    
    return authToken ? { ...tokens, Authorization: authToken } : tokens;
};
 
/**
 * Asynchronously set the tokens that will appear in the wss headers
 */
const setTokenForOperation = async operation => {
    return operation.setContext({
        headers: {
            // eslint-disable-next-line
            ... await getTokens(),
        }
    });
};

/**
 * Create the apollo link
 */
const createLinkWithToken = () =>
    new ApolloLink(
        (operation, forward) =>
            new Observable(observer => {
                let handle;
                Promise.resolve(operation)
                    .then(setTokenForOperation)
                    .then(() => {
                        handle = forward(operation).subscribe({
                            next: observer.next.bind(observer),
                            error: observer.error.bind(observer),
                            complete: observer.complete.bind(observer),
                        });
                    })
                    .catch(observer.error.bind(observer));
                return () => {
                    if (handle) handle.unsubscribe();
                };
            })
    );

const createHttpLink = () => {
    return new HttpLink({
        uri: '/graphql',
        credentials: "include"
    });
};

const logError = (error) => console.error(error);
const createErrorLink = () => onError(({ graphQLErrors, networkError, operation }) => {
    if (graphQLErrors) {
        logError('GraphQL - Error', {
            errors: graphQLErrors,
            operationName: operation.operationName,
            variables: operation.variables,
        });
    }
    if (networkError) {
        logError('GraphQL - NetworkError', networkError);
    }
})

export const createClient = (requestLink, options) => {
    const client = new ApolloClient({
        link: ApolloLink.from([
            createErrorLink(),
            createLinkWithToken(),
            ApolloLink.split(
                hasSubscriptionOperation,
                createActionCableLink(),
                createHttpLink(),
            )
        ]),
        cache: new InMemoryCache(options)
    });
    return client;
};
